export default function convertMongoIdToUTCDate(id="") {
    const timestamp = parseInt(id.substring(0, 8), 16) * 1000; // Extrai o timestamp e converte para milissegundos
    const date = new Date(timestamp); // Cria um objeto Date com o timestamp
    return date.toUTCString(); // Converte a data/hora para UTC e retorna como string
}
